export class ExpenseRoute {
    id: number = 0;
    route_name: string = '';
    expense_id: number = 0;
    expense_name: string = '';
    price: number = 0;
    expense_type_id: number = 0;
    expense_type: string = '';
    type: string = '';
    meters: number = 0;
    time: number = 0;
    gas: number = 0;
}
